import { FormControl, MenuItem, Select, SelectChangeEvent, Tooltip } from '@mui/material';
import { useSelectStructure } from './useSelectStructure';
import { useAtom } from 'jotai';
import { selectedAssemblyTemplateId as selectedAssemblyTemplateIdAtom } from '@/components/Analysis/state';
import { useGetStructureNameQuery } from '@/__generated__/graphql';
import { useGetStructureId } from '@/hooks/useGetStructureId';

export const StructureSelector = () => {
  const [selectedAssemblyTemplateId, setSelectedAssemblyTemplateId] = useAtom(
    selectedAssemblyTemplateIdAtom
  );
  const structureId = useGetStructureId();
  const { data, loading, error } = useSelectStructure();

  const { data: structureName } = useGetStructureNameQuery({
    variables: {
      structureId,
    },
  });

  if (loading) return <>...</>;
  if (error) return <>Error</>;

  const templates = data?.allTemplates;

  if (!templates?.length) return <>No templates found</>;

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedAssemblyTemplateId(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <Select
        value={selectedAssemblyTemplateId || ''}
        label="Structure"
        onChange={handleChange}
        sx={{
          color: 'white',
          '& .MuiSelect-select': {
            padding: 1,
          },
        }}
      >
        {templates.map((template) => (
          <MenuItem key={template.id} value={template.id}>
            <Tooltip
              title={structureName?.structure?.name || template.name}
              placement="bottom"
              arrow
            >
              <span>{template.name}</span>
            </Tooltip>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
